<template>
  <el-row id="biliWorks">
    <el-row>
      <el-col :span="20" :push="2">
        <h5>Bilibili的作品</h5>
      </el-col>
      <el-col :span="2" :push="2">
        <a class="el-icon-arrow-right"
           href="https://space.bilibili.com/2137919"
           target="_blank">更多</a>
      </el-col>
    </el-row>
    <el-row :gutter="20" class="row-bg" justify="center" v-for="(item, index) in works" :key="index"
            v-if="index %3==0">
      <el-col :span="8" v-for="(video,key) in works" :key="key" v-if="key - index <3 && key-index>=0">
        <el-card shadow="hover">
          <img v-bind:src="video.pic" v-on:click="viewVideo(video.aid)"/>
          <div class="video-title" v-bind:title="video.title">{{video.title}}</div>
        </el-card>
      </el-col>
    </el-row>
    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      width="40%"
      :before-close="closeModal">
      <iframe v-bind:src=playingVideo scrolling="no" style="width: 640px;height: 480px;" border="0"
              frameborder="no" framespacing="0" allowfullscreen="true"></iframe>
      <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="closeModal">关闭</el-button>
  </span>
    </el-dialog>
  </el-row>
</template>

<script>
export default {
  name: 'Bilibili',
  data () {
    return {
      works: '',
      playingVideo: '',
      dialogVisible: false
    }
  },
  mounted: function () {
    this.getBiliWork()
  },
  methods: {
    getBiliWork: function () {
      this.$http.get('static/bilibili_works.json').then(function (response) {
        var videoList = response.data.data.vlist
        this.works = videoList
      })
    },
    closeModal: function () {
      this.dialogVisible = false
      this.playingVideo = ''
    },
    viewVideo: function (aid) {
      this.playingVideo = '//player.bilibili.com/player.html?aid=' + aid + '&cid=68254646&page=1'
      this.dialogVisible = true
    }
  }
}
</script>

<style scoped>
  .row-bg {
    margin-top: 35px;
  }

  .video-title {
    overflow: hidden;
    text-align: left;
    height: 50px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Bilibili.vue